// Estado da pausa do próprio atendente, compartilhado entre o seletor de status
// (sidebar) e o BreakBanner global. Persiste em localStorage pra sobreviver a
// navegação/reload (o GET /chat/me/availability não devolve o activeBreak).

const KEY = "gk:break";
export const BREAK_EVENT = "gk:break:changed";

export interface ActiveBreakState {
  /** Nome do motivo da pausa (ex: "Treinamento"). */
  reason: string | null;
  /** ISO do início — base do contador. */
  startedAt: string;
  /** UI: faixa minimizada (true) vs overlay central (false). */
  minimized: boolean;
}

export function getBreakState(): ActiveBreakState | null {
  if (typeof window === "undefined") return null;
  try {
    const raw = localStorage.getItem(KEY);
    return raw ? (JSON.parse(raw) as ActiveBreakState) : null;
  } catch {
    return null;
  }
}

export function setBreakState(s: ActiveBreakState): void {
  if (typeof window === "undefined") return;
  try {
    localStorage.setItem(KEY, JSON.stringify(s));
  } catch {
    // localStorage indisponível — segue sem persistir
  }
  window.dispatchEvent(new Event(BREAK_EVENT));
}

export function clearBreakState(): void {
  if (typeof window === "undefined") return;
  try {
    localStorage.removeItem(KEY);
  } catch {
    // noop
  }
  window.dispatchEvent(new Event(BREAK_EVENT));
}
